import React, { useMemo } from 'react';
import { MetricCard, SpinnerDotted } from '../../atoms';
import { AttentionAlert, UserAlert } from '../../atoms/alerts';
import { LodingSquareTabbar, PreferredPartner } from '../../molecules';
import { RatingCard, CommentSection, DoughnutGraph, Bargraph } from '../../organisms';
import { totalamont, reduceCost, WellnessCalendar, calender_img, info_icon, WalletIcon } from '../../../../assets/images';
import { commaingNumber } from '../../../../utils';
import WalletUtilizationCommon from './WalletUtilizationCommon';
import { UtilizationSankyChart } from '../../../tailwind/organisms';
import { Tooltip } from 'antd';
import { CommonSplitPlot } from '../../../opdClaims';

const Benefit = ({ metricObj = {}, ratingObj = {}, utilizationObj = {}, costSavingObj = {}, sqaureTabHandler, loading, selectedContractObj, benefitType, benefitName, walletUtilizationObj = {}, showNoUtilization}) => {
  const {
    healthCheckAvailedPercentage, successMetric, donutGraphData = [], partners = [], activeEmployeesAppointmentsCount, inactiveEmployeesAppointmentsCount,
    activeDependentsAppointmentsCount, inactiveDependentsAppointmentsCount, totalHealthChecksCompleted, unique_users, repeat_users, activeCustomerCount,
    activeEmployeesUpcomingAppointmentsCount, activeDependentsUpcomingAppointmentsCount, totalAmountSpent,
    activeUniqueEmployeesAppointmentsCount = 0, inactiveUniqueEmployeesAppointmentsCount = 0, hasCustomerFormSubmissions,
    activeUniqueDependentsAppointmentsCount = 0, inactiveUniqueDependentsAppointmentsCount = 0
  } = metricObj;

  const { ratingsPercent, totalratings, averagerating, commentSectionData = [] } = ratingObj;
  const { barlabels = [], bardata = [], barBgColors = [], xAxesLabel } = utilizationObj;
  const { appointment_count, cost, savings, self_savings } = costSavingObj;
  const currentYear = selectedContractObj?.is_running_contract

  const tooltipText = (selfCount = 0, dependentCount = 0) => {
    return (
      <div>
        {employeeData('Self appointments', selfCount)}
        {employeeData('Dependents appointments', dependentCount)}
        <hr className='my-3' />
        {employeeData('Total appointments', selfCount + dependentCount)}
      </div>
    )
  }

  const employeeData = (text, count) => {
    return (
      <div className='flex justify-between'>
        <span className='font-semibold'>{text}</span>
        <span className='font-semibold'>{commaingNumber(count)}</span>
      </div>
    )
  }

  const metricValueSuffix = (selfCount, dependentCount, benefitName='appointments') => {
    return (
      <span >
        <span className='font-semibold text-gray-800'>
        Upcoming {benefitName}
        </span>
        <Tooltip placement='bottom' title={tooltipText(selfCount, dependentCount)} overlayStyle={{width: '16rem'}}>
          {/* <img src={info_icon} className='h-3 w-3 ml-1 inline cursor-pointer' alt='info_icon' /> */}
        </Tooltip>
      </span>
    )
  }

  const sankyChartData = useMemo(() => {
    const employeesAppointmentsCount = (activeEmployeesAppointmentsCount || 0) + (activeDependentsAppointmentsCount || 0)
    const dependentsAppointmentsCount = (inactiveEmployeesAppointmentsCount || 0) + (inactiveDependentsAppointmentsCount || 0)

    const totalUnique = (activeUniqueEmployeesAppointmentsCount || 0) + (inactiveUniqueEmployeesAppointmentsCount || 0) +
      (activeUniqueDependentsAppointmentsCount || 0) + (inactiveUniqueDependentsAppointmentsCount || 0)
    const uniqueActiveBranch = (activeUniqueEmployeesAppointmentsCount || 0) + (activeUniqueDependentsAppointmentsCount || 0)
    const uniqueInactiveBranch = (inactiveUniqueEmployeesAppointmentsCount || 0) + (inactiveUniqueDependentsAppointmentsCount || 0)

    const logValue = (v) => {
      const scaled = Math.log((v || 1) + 1)
      return Math.max(0.8, scaled)
    }
    const v24 = logValue(activeUniqueEmployeesAppointmentsCount)
    const v25 = logValue(activeUniqueDependentsAppointmentsCount)
    const v36 = logValue(inactiveUniqueEmployeesAppointmentsCount)
    const v37 = logValue(inactiveUniqueDependentsAppointmentsCount)

    const LINE_BREAK = '__BR__'
    // First node: total users + completed appointments
    const point1 = `${commaingNumber(totalUnique)} Users${LINE_BREAK}(Completed ${commaingNumber(totalHealthChecksCompleted || 0)} appointments)`
    // Second node: Active / Inactive users + completed appointments
    const point2 = `${commaingNumber(uniqueActiveBranch)} Active Users${LINE_BREAK}(Completed ${commaingNumber(employeesAppointmentsCount || 0)} appointments)`
    const point3 = `${commaingNumber(uniqueInactiveBranch)} Inactive Users${LINE_BREAK}(Completed ${commaingNumber(dependentsAppointmentsCount || 0)} appointments)`
    // Third node under Active: Employees / Dependents
    const point4 = `${commaingNumber(activeUniqueEmployeesAppointmentsCount || 0)} Employees${LINE_BREAK}(Completed ${commaingNumber(activeEmployeesAppointmentsCount || 0)} appointments)`
    const point5 = `${commaingNumber(activeUniqueDependentsAppointmentsCount || 0)} Dependents${LINE_BREAK}(Completed ${commaingNumber(activeDependentsAppointmentsCount || 0)} appointments)`
    // Third node under Inactive: Employees / Dependents (added space to force uniqueness)
    const point6 = `${commaingNumber(inactiveUniqueEmployeesAppointmentsCount || 0)} Employees ${LINE_BREAK}  (Completed ${commaingNumber(inactiveEmployeesAppointmentsCount || 0)} appointments)`
    const point7 = `${commaingNumber(inactiveUniqueDependentsAppointmentsCount || 0)} Dependents ${LINE_BREAK}(Completed ${commaingNumber(inactiveDependentsAppointmentsCount || 0)} appointments)`

    const data = {
      nodes: [{ id: point1 }, { id: point2 },
              { id: point3 }, { id: point4 },
              { id: point5 }, { id: point6 },
              { id: point7 }],
      links: [
        { source: point1, target: point2, value: v24 + v25 },
        { source: point1, target: point3, value: v36 + v37 },
        { source: point2, target: point4, value: v24 },
        { source: point2, target: point5, value: v25 },
        { source: point3, target: point6, value: v36 },
        { source: point3, target: point7, value: v37 }
      ]
    }

    const colors = ['#0951E1', '#00A04F', '#C54B4F', '#1FBDC0', '#5163BA', '#4D6189', '#8895AF']
    return { data, colors }
  }, [
    totalHealthChecksCompleted,
    activeEmployeesAppointmentsCount, inactiveEmployeesAppointmentsCount, activeDependentsAppointmentsCount, inactiveDependentsAppointmentsCount,
    activeUniqueEmployeesAppointmentsCount, inactiveUniqueEmployeesAppointmentsCount,
    activeUniqueDependentsAppointmentsCount, inactiveUniqueDependentsAppointmentsCount
  ])

  const formattedDistributionData = useMemo(() => {
    const formatted = {};
    barlabels.forEach((label, index) => {
      const val = bardata[index];
      const volume = typeof val === 'object' ? val.t : val;
      const key = xAxesLabel === 'Age' ? `${label} age group` : label;
      formatted[key] = {
        volume: volume,
        amount: 0 
      };
    });
    return formatted;
  }, [barlabels, bardata, xAxesLabel]);


  return (
    <div>
      {(!loading && currentYear && healthCheckAvailedPercentage < successMetric) &&
        <AttentionAlert
          title='Attention Required'
          description={
            <span>
              Utilization for your organization is low as per the success metrics set for your organization. To improve
              the utilization please reach out to your{' '}
              <span className='text-blue-500 font-semibold'>
                customer success manager.
              </span>
            </span>
          }
          classes='mt-6'
        />}
      <p className='text-gray-700 text-base font-semibold mt-8 mb-3 leading-none'>Sponsored {benefitName} Summary</p>
      { !loading ?
        <>

          <div className='flex flex-row space-between'>
            {/* { walletEnable && (totalWalletAmount >0) && (<MetricCard
              loading={loading}
              loaderHeight={120}
              svgsrc={WalletIcon}
              titleClasses='font-semibold text-gray-800'
              title='Total amount added'
              subTitle='Total amount added for employee and dependent wallet utilization'
              metricClasses='flex mt-0 text-gray-500'
              metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>₹{commaingNumber(totalWalletAmount)}</span>}
              classes='w-1/2 inline-block mr-5'
            />) */}
            {
              <MetricCard
                loading={loading}
                loaderHeight={120}
                svgsrc={totalamont}
                titleClasses='font-semibold text-gray-800'
                title={`Total amount spent on sponsored ${benefitName}`}
                subTitle='Calculated based on completed appointments only'
                metricClasses='flex mt-4 text-gray-500'
                metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>₹{commaingNumber(totalAmountSpent)}</span>}
                classes='w-1/2 inline-block mr-5'
              />
            }
            { showNoUtilization == false && (<MetricCard
              loading={loading}
              loaderHeight={120}
              svgsrc={calender_img}
              titleClasses='font-semibold text-gray-800'
              title={`Completed ${benefitName}`}
              subTitle='Completed (unique) appointments for self and dependents'
              metricClasses='flex mt-4 text-gray-500'
              metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(totalHealthChecksCompleted)}</span>}
              metricValueSuffix='appointments'
              classes='w-1/2 inline-block mr-5'
            />)}
            { showNoUtilization == false && (<MetricCard
              loading={loading}
              loaderHeight={120}
              svgsrc={WellnessCalendar}
              titleClasses='font-semibold text-gray-800'
              title={metricValueSuffix(activeEmployeesUpcomingAppointmentsCount, activeDependentsUpcomingAppointmentsCount, benefitName)}
              subTitle='Upcoming (unique) appointments for self and dependents'
              metricClasses='flex mt-4 text-gray-500'
              metricValue={<span className='ml-10 font-semibold text-3xl text-gray-700'>{commaingNumber(activeEmployeesUpcomingAppointmentsCount + activeDependentsUpcomingAppointmentsCount)}</span>}
              metricValueSuffix='appointments'
              classes='w-1/2 inline-block'
            />)}
          </div>

          { showNoUtilization == false && (<div><p className='text-gray-600 text-base font-semibold mt-8 mb-3 leading-none'>User-wise Appointment Breakdown</p>

        <UtilizationSankyChart sankeyData={sankyChartData} classes='px-9 py-20 border bg-white border-gray-200' height={450} /></div>)}
        </> :
        <div className='h-40 flex items-center justify-center'><SpinnerDotted /></div>
      }

      <WalletUtilizationCommon metricObj={metricObj}  loading={loading} benefitName={benefitName} walletUtilizationObj={walletUtilizationObj} uniqueUsers={unique_users} activeCustomerCount={activeCustomerCount}/>
    { showNoUtilization == false && (<div>
      <div className='flex flex-row justify-between mt-12'>
        <div className='flex flex-col w-1/2 mr-4'>
          <p className='text-gray-600 text-base font-semibold mb-3 leading-none'>{benefitName} Completion Modes</p>
          <div className='text-sm mb-3 text-gray-600'>
            Distribution of completed {benefitName} appointments by mode
          </div>
          <DoughnutGraph
            loading={loading}
            loaderHeight={200}
            title={benefitName}
            graphData={donutGraphData}
            classes='h-full'
            heightOfLoader={200}
            id={benefitType}
            hideBrackets={true}
          />
        </div>
        <div className='flex flex-col w-1/2'>
          <p className='text-gray-600 text-base font-semibold mb-3 leading-none'>
            Top Preferred Providers
          </p>
          <div className='text-sm mb-3 text-gray-600'>
            Ranks partner providers based on no. of employees who selected them for completing their appointments
          </div>
          <PreferredPartner loading={loading} loaderHeight={200} list={partners} header='Partners' classes='h-full' />
        </div>
      </div>
      {hasCustomerFormSubmissions && <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'> *Also includes data from the form submitted by the customer</p>}

      {/* <div>
        {benefitArrForSponsoredAndMoneySpent.includes(benefitType) &&(
        <div>
          <p className='text-gray-500 text-base font-semibold mt-12 mb-3 leading-none'>
            Spent and savings on {benefitName?.toLowerCase()}
          </p>
            <div className='flex flex-row'>
              <MetricCard
                loading={loading}
                loaderHeight={120}
                svgsrc={totalamont}
                titleClasses='block'
                title={`Total amount spent on sponsored ${benefitName?.toLowerCase()}`}
                metricValue={<span className='font-semibold text-3xl text-gray-700 mt-3'>₹{commaingNumber(cost)}</span>}
                classes='w-1/3 inline-block mr-5'
              />
              <MetricCard
                loading={loading}
                loaderHeight={120}
                svgsrc={reduceCost}
                titleClasses='block'
                title={`Amount saved by you on sponsored ${benefitName?.toLowerCase()}`}
                metricValue={<span className='font-semibold text-3xl text-gray-700'>₹{commaingNumber(savings)}</span>}
                classes='w-1/3 inline-block mr-5'
              />
              <MetricCard
                loading={loading}
                loaderHeight={120}
                svgsrc={reduceCost}
                titleClasses='block'
                title={
                  <span>
                    Amount saved by you on self paid {benefitName?.toLowerCase()}<span className='font-semibold text-lg leading-3'>*</span>
                  </span>
                }
                metricValue={<span className='font-semibold text-3xl text-gray-700'>₹{commaingNumber(self_savings)}</span>}
                classes='w-1/3 inline-block'
              />
            </div>
          <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'>
            <span className='font-semibold'>*{appointment_count}</span> additional tests/packages were availed by
              employees/dependents on self paid basis
          </p>
        </div>)}
      </div>  */}

      {(totalratings > 0 || commentSectionData?.length > 0) && <><div className='flex flex-row mt-12'>
        <div className='flex flex-col w-2/4 pr-4'>
          <div className='text-base font-semibold text-gray-500 leading-none mb-1'>Ratings and Reviews</div>
          <div className='text-sm mb-3 text-gray-600'>
            These ratings are captured after completing the {benefitName?.toLowerCase()}
          </div>
          <RatingCard
            loading={loading}
            loaderHeight={200}
            rating={averagerating}
            number_of_ratings={totalratings}
            five_star_rating={ratingsPercent && ratingsPercent[4]}
            four_star_rating={ratingsPercent && ratingsPercent[3]}
            three_star_rating={ratingsPercent && ratingsPercent[2]}
            two_star_rating={ratingsPercent && ratingsPercent[1]}
            one_star_rating={ratingsPercent && ratingsPercent[0]}
            classes='h-full'
          />
        </div>

        <div className='w-2/4 flex flex-col'>
          <div className='text-base font-semibold text-gray-500 leading-none mb-1'>Top Comments</div>
          <div className='text-sm mb-3 text-gray-600'>
            These reviews are captured after completing the {benefitName?.toLowerCase()}
          </div>
          <CommentSection loading={loading} loaderHeight={200} points={commentSectionData} classes='h-full' />
        </div>
      </div>
      {hasCustomerFormSubmissions && <p className='text-sm text-gray-600 mt-2 mb-0 italic leading-none'> *Also includes data from the form submitted by the customer</p>}
      </>
      }

      <div className='mt-12'>
        <div className='text-base font-semibold text-gray-700 leading-none'>Employee Profile Distribution</div>
          <div className='text-sm my-1 text-gray-600'>
            Share of employees (who completed at least one appointment) by department, location, age group, and gender
          </div>
        <LodingSquareTabbar
          loading={loading}
          loaderHeight={25}
          list={['Departments', 'Location', 'Age', 'Gender']}
          handler={sqaureTabHandler}
          classes='mt-3'
        />
        <div className='mt-5'>
          {bardata && bardata.length === 0 ? (
            <div className='bg-white rounded-md p-6'>
              <UserAlert
                para={`${xAxesLabel} data is not available`}
                paraClasses=' font-semibold text-gray-600'
                imgClasses=' h-5 w-5'
                classes='p-4'
              />
            </div>
          ) : (
            <CommonSplitPlot
              data={formattedDistributionData}
              title={xAxesLabel}
              loading={loading}
              initialMetric='volume'
              hideToggle={true}
              hideSummary={true}
              hideAov={true}
              hideImage={true}
              precision={2}
              shareLabel='%Share'
              hideBrackets={true}
            />
          )}
        </div>
      </div>
      </div>)}
    </div>
  );
};

export default Benefit;
